import { camelCase, filter, isEmpty, trim } from 'lodash';
import projectResource from '../../../locales/th/project.json';

export function getRoomDetailConfig(roomProfile, equipment, sink, stove_hood) {
  return [
    {
      label: projectResource.otherProjectDetail.roomDetails.ceilingHeight,
      value: roomProfile.ceiling_height,
    },
    {
      label: projectResource.otherProjectDetail.roomDetails.standardEquipment,
      value: equipment.label,
    },
    {
      label: projectResource.otherProjectDetail.roomDetails.kitchenAndSink,
      value: !isEmpty(sink.label)
        ? projectResource.projectInformation[camelCase(sink.label)]
        : '',
    },
    {
      label: projectResource.otherProjectDetail.roomDetails.stoveAndHood,
      value: !isEmpty(stove_hood.label)
        ? projectResource.projectInformation[camelCase(stove_hood.label)]
        : '',
    },
  ];
}

export function showRoomInformationFields(value) {
  const roomDetailWithValue = filter(value, (item) => !isEmpty(item.value));
  return {
    setIsShowMoreRoomDetails: false,
    setShowRoomDetails: roomDetailWithValue,
  };
}

export function showPublicUtilitiesInformationFields(value) {
  const publicUtilitiesWithValue = filter(
    value,
    (item) => item.value !== 'N' && trim(item.value),
  );
  return {
    setIsShowMorePublicUtilities: false,
    setShowPublicUtilities: publicUtilitiesWithValue,
  };
}

export function showSecuritesInformationFields(value) {
  const securitiesWithValue = filter(
    value,
    (item) => item.value !== 'N' && trim(item.value),
  );
  return {
    setIsShowMoreSecurities: false,
    setShowSecurities: securitiesWithValue,
  };
}
